import { Component, OnInit, AfterViewInit, ViewChild, ElementRef, ViewEncapsulation } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormControl, FormGroup, FormBuilder, Validators } from '@angular/forms';
import { HttpClient, HttpParams } from '@angular/common/http';

@Component({
  selector: 'app-reserv',
  templateUrl: './reserv.component.html',
  styleUrls: ['./reserv.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class ReservComponent implements OnInit {

  @ViewChild('btn') public btnComb: ElementRef;

  addData: FormGroup;

  formErrors = {
    "depreg": "",
    "deptsc": "",
    "numb": "",
    "depregcomb": "",
  };

  validationMessages = {
    "numb": {
      "required": "Обов'якове поле.",
      "pattern": "XX1111XX.",
      // "maxlength": "Максимум 6 символів.",
      // "minlength": "Мінімум 6 символів.  ",
  },
  };

  constructor(private router: Router, private http: HttpClient, private fb: FormBuilder) { }

  ngOnInit() {
    this.buildForm();
  }

  buildForm() {
    this.addData = this.fb.group({
        "numb": ['', [
            Validators.required,
            // Validators.minLength(6),
            // Validators.maxLength(6),
            Validators.pattern("[a-z]{2}[0-9]{4}[a-z]{2}"),
        ]]
    });

    this.addData.valueChanges
        .subscribe(data => this.onValueChange(data));

    this.onValueChange();
    
    if (this.addData.valid) {
      this.btnComb.nativeElement.className = "button_success";
    }

  }

  onValueChange(data?: any) {

    if (!this.addData) return;
    let form = this.addData;

    for (let field in this.formErrors) {
        this.formErrors[field] = "";
      
        let control = form.get(field);

        if (control && control.dirty && !control.valid) {
            let message = this.validationMessages[field];
            for (let key in control.errors) {
                this.formErrors[field] += message[key] + " ";
            }
        }
    }
  } 

  backToMain() {
    this.router.navigateByUrl('/', { skipLocationChange: false }).then(() => {
    this.router.navigate(['/']);
    });
  }

  fetchData(inn_buy:any, inn_sell:any, car_id:any) {
    console.log('bla');
    this.http.get('https://mainapi.hsc.gov.ua/licenseplate-service/whs/plates/regnum?regionid=' + inn_buy + '&number=' + inn_sell)
    .subscribe (
      data => {
        // console.log(data);
        //  this.dnzCombinationSelect = data;
         if (data != null) {
        //  console.log('Its pv');
      //    this.dnzParameters.forEach( (item:any) => {
      //    this.dnzParameters = item.categories;
      //   //  console.log(this.pvCategories);
      // this.dtTriggerPlate.next();

      // let currentDatePl = moment().locale('uk');
      // this.timePl = currentDatePl.format('DD.MM.YYYY HH:mm:ss');

      const outData: HTMLElement = document.getElementById('four');
      const enterParam: HTMLElement = document.getElementById('three');

      enterParam.classList.add('animate__animated', 'animate__zoomOutDown');
      setTimeout(() => enterParam.hidden = true, 900);

      outData.classList.add('animate__animated', 'animate__zoomInDown');
      setTimeout(() => document.getElementById("four").style.display = "block", 900);

      //  });
      } else {
        console.log('Not found '); 
        this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
          this.router.navigate(['message']);
          }); 
      }
    },
         err => console.log(err)
    )

}

}
